module.exports = __webpack_public_path__ + "img/link_gsw.e9397d76.png";